import { render, staticRenderFns } from "./LeccionD1.vue?vue&type=template&id=4361f10c&"
import script from "./LeccionD1.vue?vue&type=script&lang=js&"
export * from "./LeccionD1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports